import { Directive, ElementRef, HostListener, Input, EventEmitter, Output, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { Validator, FormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[appMaxLength]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: MaximumLengthDirective, multi: true },
    ]
})

export class MaximumLengthDirective implements Validator {
    @Input() ngModel;
    @Input() maximumlength: string | number;

    @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

    constructor(private elementRef: ElementRef) {
    }

    @HostListener('paste', ['$event']) onPaste(event) {
        try {
            event.preventDefault();
        } catch (ex) {
            console.error(`paste exception ${ex.toString()}`);
        }
    }

    validate(control: FormControl) {
        const currentValue = control.value;
        return this.checkMaxLength(currentValue);
    }

    checkMaxLength(currentValue) {
        try {
            if (!this.maximumlength || !currentValue) {
                return null;
            }
            return currentValue.length > this.maximumlength ? Object.assign({}, { maxlength: true }) : null;
        } catch (ex) {
            console.error(`checkMaxLength exception ${ex.toString()}`);
        }
    }
}
